var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "view",
          rawName: "v-view",
          value: _vm.viewHandler,
          expression: "viewHandler",
        },
      ],
      staticClass: "rb-editorial__video-background",
    },
    [
      _c(
        "video",
        {
          ref: "video",
          attrs: {
            preload: "metadata",
            playsinline: "",
            autoplay: _vm.autoplay,
            loop: _vm.loop,
            poster: _vm.cover,
          },
          domProps: { muted: _vm.isMuted },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.videoText ? _c("p", [_vm._v(_vm._s(_vm.videoText))]) : _vm._e(),
      _vm._v(" "),
      _vm.controls
        ? _c(
            "div",
            {
              staticClass: "rb-editorial__video-controllers",
              class: _vm.controlsPositionClass,
            },
            [
              _vm.audioTogglesEnabled
                ? _c(
                    "button",
                    {
                      class: { "btn-disabled": _vm.playing },
                      attrs: {
                        type: "button",
                        "data-element-id": "X_Pdp_Video_Play",
                        "data-description": _vm.videoName,
                        "aria-label": "play",
                      },
                      on: { click: _vm.play },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "common__icon common__icon--vp-play" },
                        [_vm._v("play")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: { "btn-disabled": !_vm.playing },
                  attrs: {
                    type: "button",
                    "data-element-id": "X_Pdp_Video_Pause",
                    "data-description": _vm.videoName,
                    "aria-label": "pause",
                  },
                  on: { click: _vm.pause },
                },
                [
                  _c(
                    "span",
                    { staticClass: "common__icon common__icon--vp-pause" },
                    [_vm._v("pause")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-audio",
                  class: { "btn-disabled": _vm.isMuted },
                  attrs: {
                    type: "button",
                    "data-element-id": "X_Pdp_Video_Audio",
                    "data-description": _vm.videoName,
                    "aria-label": "audio toggle",
                  },
                  on: { click: _vm.toggleAudio },
                },
                [
                  _c(
                    "span",
                    { staticClass: "common__icon common__icon--vp-speaker" },
                    [_vm._v("audio toggle")]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }